import AjaxRequest from '@wgn/ajaxrequest';

const DEFAULT_CONFIG = {
    method: 'GET',
    data: {},
    headers: {},
};

export default function promisifiedAjaxRequest(params = {}) {
    return new Promise((resolve, reject) => {
        const config = { ...DEFAULT_CONFIG, ...params };
        const {
            method, data, url, headers,
        } = config;

        AjaxRequest.submit(data, {
            method,
            url,
            headers,
            success: response => {
                resolve(response);
            },
            error: error => {
                reject(error);
            },
        });
    });
}
